export enum EnumPrintLocType {
  InHouse = "In-House",
  PrivateLabel = "Private Label",
  Transport = "Transport",
  InternalWash = "Internal Wash",
  UpgradeWash = "Upgrade Wash",
  MaintenanceWash = "Maintenance Wash",
  StorageFacility = "Storage Facility",
  StorageTanks = "Storage Tanks",
  Repack = "Repack",
}
